class Errors {
  /**
   * Create an empty object property
   */
  constructor() {
    this.errors = {};
  }

  /**
   *
   * Get all of the error messages
   *
   * @returns Array
   */
  all() {
    return this.errors;
  }

  /**
   *
   * Get an error for a specific field
   *
   * @param {string} field
   * @returns string
   */
  get(field) {
    if (this.errors[field]) {
      return this.errors[field][0];
    }
  }

  /**
   *
   * Clear the errors for the given field
   *
   * @param {string} field
   */
  clear(field) {
    if (field) {
      delete this.errors[field];
      return;
    }

    this.errors = {};
  }

  /**
   * Check to see if the given field has any errors
   *
   * @param {string} field
   * @returns {boolean}
   */
  has(field) {
    return !!this.errors[field];
  }

  /**
   * Check to see if there are any errors
   *
   * @returns {boolean}
   */
  any() {
    return Object.keys(this.errors).length > 0;
  }

  /**
   * Save the errors in the errors property
   *
   * @param {object} errors
   */
  record(errors) {
    this.errors = errors;
  }
}

export default Errors;
